import { Box, Typography } from '@mui/material';
import { PageBase } from '../PageBase';
import { theme } from '@/styles/theme';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { TableCell } from '@/components/tableCell/TableCell';

export const TermsOfUse = () => {
  const { t } = useTranslation('termsOfUse');
  const navigate = useNavigate();

  return (
    <PageBase title={t('create_password')} onBackClick={() => navigate(-1)} paddingInline={0}>
      <Box sx={{ mt: 2, display: 'flex', flexDirection: 'column', gap: 4 }}>
        <Box>
          <Typography
            sx={{
              fontSize: '1.8rem',
              fontWeight: 600,
              color: theme.palette.primary.main,
            }}
          >
            {t('title')}
          </Typography>
          <Typography
            sx={{
              fontSize: '1.4rem',
              fontWeight: 400,
            }}
          >
            {t('description')}
          </Typography>
        </Box>
        <Box>
          <Typography
            sx={{
              fontSize: '1.4rem',
              fontWeight: 600,
            }}
          >
            {t('section_title')}
          </Typography>
          <Typography
            sx={{
              fontSize: '1.4rem',
              fontWeight: 400,
            }}
          >
            {t('section_description')}
          </Typography>
        </Box>
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'column', marginTop: 3.3 }}>
        <TableCell
          title={t('top_button_title')}
          description={t('top_button_description')}
          showLeftIcon={true}
          iconLeftType={'bracket'}
          showRightIcon={true}
          iconRightType={'arrow'}
          onAction={() => navigate('/telemedicine')}
        />
        <TableCell
          title={t('bottom_button_title')}
          description={t('bottom_button_description')}
          showLeftIcon={true}
          iconLeftType={'inform'}
          showRightIcon={true}
          iconRightType={'arrow'}
          onAction={() => navigate('/cancellation_policy')}
        />
      </Box>
    </PageBase>
  );
};
